import { Container } from 'pixi.js';
import { LevelLockMenuIconOverlayLayout } from '../../layouts/common/LevelLockMenuIconOverlayLayout';
import { TextBubbleView } from './TextBubbleView';
import { getLocalized } from '../libs/layouts/initPopulate';
import { SpeechBubbleSide } from './SpeechBubbleView';
import { applyLayoutState } from '../libs/layouts/populateLayouts/applyLayoutState';

export class LevelLockMenuIconOverlay extends Container {
  private readonly layout = new LevelLockMenuIconOverlayLayout();

  private showBubble: Container | null = null;

  constructor(unlockLevelNumber: number, speechBubbleOptions?: { pointerToRight?: boolean, bubbleText?: string}) {
    super();

    const { root, unlockLevelText, bubbleSlot } = this.layout;

    root.props({ parent: this });
    unlockLevelText.text = unlockLevelText.text.replace('<nr>', `${unlockLevelNumber}`);

    if (speechBubbleOptions?.pointerToRight) {
      applyLayoutState(this.layout, 'pointerRight');
    }

    root.on('pointertap', async () => {
      if (this.showBubble || this.destroyed) return;

      const bubbleText = speechBubbleOptions?.bubbleText ?? getLocalized('Reach Level <nr> to unlock').replace('<nr>', `${unlockLevelNumber}`);

      this.showBubble = new TextBubbleView({
        text: bubbleText,
        pointer: { side: speechBubbleOptions?.pointerToRight ? SpeechBubbleSide.Right : SpeechBubbleSide.Left, anchor: 0.5 },
      }).props({
        parent: bubbleSlot,
      });
      this.showBubble?.tweenFrom({ scaleXY: 0 }, 200, 'appear1', true);

      await this.wait(2000);
      if (this.destroyed) return;

      await this.showBubble?.tweenTo({ scaleXY: 0 }, 200, 'disappear1', true).asyncOnComplete();
      this.showBubble = null;
    });
  }
}
